import React from 'react'
import {Box} from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import RoundActionButtonNew from './RoundActionButtonNew'

// The "Hai assunto la terapia?" answer, as two large round buttons instead of text — the same
// RoundActionButtonNew as the list's QuickAnswerButtonsNew, just bigger: this is the one
// full-page decision a reminder link exists for, so it gets the size to match, but not a
// different metaphor. The selected one fills solid (white icon on the semantic color) so
// reopening an already-answered reminder makes the previous choice obvious at a glance.

interface AssumptionTakenChoiceNewProps {
  value: 'yes' | 'no' | null
  onChange: (value: 'yes' | 'no') => void
  disabled?: boolean
}

const SIZE = 56

export default function AssumptionTakenChoiceNew({
  value,
  onChange,
  disabled
}: AssumptionTakenChoiceNewProps): JSX.Element {
  return (
    <Box sx={{display: 'flex', gap: 3}}>
      <RoundActionButtonNew
        tone="confirm"
        label="Sì, l'ho assunta"
        size={SIZE}
        selected={value === 'yes'}
        disabled={disabled}
        onClick={() => onChange('yes')}
      >
        <CheckIcon />
      </RoundActionButtonNew>
      <RoundActionButtonNew
        tone="deny"
        label="No, non l'ho assunta"
        size={SIZE}
        selected={value === 'no'}
        disabled={disabled}
        onClick={() => onChange('no')}
      >
        <CloseIcon />
      </RoundActionButtonNew>
    </Box>
  )
}
